import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { VinValidate } from "src/app/models/vin-validate/vin-validate";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class VehicleInformationService {

    private apiUrl = environment.apiUrl;
    private vinValidate: VinValidate;

    constructor(private httpClient: HttpClient) {
    }
   
    setAllChassiValidation(vinValidate: VinValidate) {
      this.vinValidate = vinValidate;
    }

    getAllChassiValidation(): VinValidate {
      return this.vinValidate;
    }

    getAllChassiValidationClean() {
      this.vinValidate = new VinValidate();
    }
}
